import { HomeRankingProductTabsRender } from "./home-ranking-product-tabs-render";
import type { HomeRankingProductTabsForm } from "./home-ranking-product-tabs-form";

export class HomeRankingProductTabsHandler {
    private readonly form: HomeRankingProductTabsForm;

    public constructor(form: HomeRankingProductTabsForm) {
        this.form = form;
    }

    public bootstrap(): void {
        const tabs = this.form.getTabs();
        const panels = this.form.getPanels();
        if (tabs.length === 0 || panels.length === 0) return;

        const initial = this.form.getInitialParentCategoryId() || tabs[0]?.dataset.parentCategoryId || null;
        if (!initial) return;

        HomeRankingProductTabsRender.renderActive(tabs, panels, initial);
        this.notifyLayoutChanged();
    }

    public handleTabClick(event: Event, parentCategoryId: string | null | undefined): void {
        if (!parentCategoryId) return;

        event.preventDefault();

        const tabs = this.form.getTabs();
        const panels = this.form.getPanels();
        HomeRankingProductTabsRender.renderActive(tabs, panels, parentCategoryId);
        this.notifyLayoutChanged();
    }

    public notifyLayoutChanged(): void {
        setTimeout(() => {
            dispatchEvent(new Event("resize"));
        }, 0);
    }
}
